<template>
	
	<select class="form-control" :name="name" v-on:change="change" v-on:input="updateValue($event.target.value)">
		<slot></slot>
		<option v-for="group in groups" :value="group.id">{{ group.name }}</option>
	</select>
	
</template>

<script type="text/javascript">
	export default {
		name: "GroupsSelect",
		props: ["name", "groups"],
		methods: {
			change () {
				this.$emit("change")
			},
			updateValue(value) {
				this.$emit("input",value)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// GroupsSelect.vue?1bcf56fa